import { Form } from 'antd'
import AntdPhoneInput from 'antd-phone-input'
import type {
  PhoneInputProps as AntdPhoneInputProps,
  PhoneNumber
} from 'antd-phone-input'
import type { CSSProperties } from 'react'

export type PhoneInputProps = Omit<
  AntdPhoneInputProps,
  'value' | 'onChange' | 'style'
> & {
  inputStyle?: CSSProperties
  onChange?: (value: string) => void
  value?: string | number
}

const toRawValue = (phone: PhoneNumber) =>
  [phone.countryCode, phone.areaCode, phone.phoneNumber]
    .filter(
      (part) => part !== undefined && part !== null && String(part) !== ''
    )
    .join('')

export const PhoneInput = ({
  value,
  onChange,
  inputStyle,
  country = 'md',
  enableSearch = true,
  enableArrow = true,
  preferredCountries = ['md', 'ro'],
  ...props
}: PhoneInputProps) => {
  const { status } = Form.Item.useStatus()
  const raw = value == null ? '' : String(value)

  return (
    <AntdPhoneInput
      value={raw || undefined}
      useSVG
      onChange={(phone) => {
        const nextValue = toRawValue(phone)
        onChange?.(nextValue)
      }}
      country={country}
      enableSearch={enableSearch}
      enableArrow={enableArrow}
      preferredCountries={preferredCountries}
      status={status === 'error' || status === 'warning' ? status : undefined}
      style={{ width: '100%', ...inputStyle }}
      {...props}
    />
  )
}
